if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.previousAdditionalVariantId = null;
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();

        if (this.previousAdditionalVariantId !== null && this.previousAdditionalVariantId !== '') {
          sessionStorage.setItem('additionalVariantId', this.previousAdditionalVariantId);
        } else {
          sessionStorage.removeItem('additionalVariantId');
        }
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const storedVariantId = sessionStorage.getItem('additionalVariantId');
        if (storedVariantId !== null && storedVariantId !== '') {
          this.previousAdditionalVariantId = storedVariantId;
        } else {
          this.previousAdditionalVariantId = null;
        }
        sessionStorage.removeItem('additionalVariantId');

        this.productUrl = opener.getAttribute('data-product-url');
        if (this.productUrl.includes('?')) this.productUrl = this.productUrl.split('?')[0];

        if (opener.getAttribute('data-product-template')) {
          this.productTemplate = opener.getAttribute('data-product-template');
          this.plainTemplate = false;
        } else {
          this.productTemplate = 'quick-add-modal';
          this.plainTemplate = true;
        }

        fetch(this.productUrl + `?view=${this.productTemplate}`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            let productElement = this.plainTemplate ? responseHTML.querySelector('#modal-content') : responseHTML.querySelector('[id*="MainProduct-"]')?.closest('.shopify-section');

            if (!this.plainTemplate) {
              const excludeSelectors = [
                '.product__media-wrapper',
                '.product__sticky-atc',
                '#ingredientsPopup',
                '[data-variant-description]',
                '[data-enhanced-atc-exclude]'
              ];

              excludeSelectors.forEach(selector => {
                productElement.querySelectorAll(selector).forEach(node => node.remove());
              });

              const productInfo = productElement.querySelector('[id*="ProductInfo-"]');
              if (productInfo) {
                let variantSelector;
                if (this.productTemplate.includes('mixed-bogo')) {
                  variantSelector = '[id*="variant-picker--"]';
                } else {
                  variantSelector = productInfo.querySelector('[data-set-variants]') ? '[data-set-variants]' : 'variant-selects';
                }
                const productInfoAllowedSelectors = [
                  '[id*="price-"]',
                  `${variantSelector}`,
                  '[data-enhanced-atc]'
                ];

                const newProductInfo = productInfo.cloneNode(false);

                const titleEl = document.createElement('h2');
                titleEl.className = 'bodytext-lg mb-2';
                titleEl.textContent = opener.getAttribute('data-product-title');
                newProductInfo.appendChild(titleEl);

                productInfoAllowedSelectors.forEach(sel => {
                  productInfo.querySelectorAll(sel).forEach(node => {
                    newProductInfo.appendChild(node.cloneNode(true));
                  });
                });

                if (newProductInfo.children.length > 0) productInfo.replaceWith(newProductInfo);
                productElement.querySelector('[data-update-url="true"]')?.setAttribute('data-update-url', 'false');
                productElement.querySelector('[data-swiper-general]')?.removeAttribute('data-swiper-general');
              }
            }

            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (this.plainTemplate) {
              const modalVariantListener = this.querySelector('[data-id-listener-quick-add-modal]');
              modalVariantListener.addEventListener('change', () => {
                this.querySelector('input[name="id"]').value = modalVariantListener.value;
              });
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}